export enum DeliveryCommunicationFrequency {
  FIRST_THEN_LAST = 'firstThenLast',
  REAL_TIME = 'realTime',
}
